package io.peekandpoke.ultra.datetime

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

object MpLocalDateTimeSerializer : KSerializer<MpLocalDateTime> {

    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("MpLocalDateTimeSerializer", PrimitiveKind.STRING)

    override fun serialize(encoder: Encoder, value: MpLocalDateTime) {
        encoder.encodeSerializableValue(
            serializer = MpDateTimeRawData.serializer(),
            value = MpDateTimeRawData(
                ts = value.toInstant(MpTimezone.UTC).toEpochMillis(),
                timezone = "UTC",
                human = value.toIsoString()
            )
        )
    }

    override fun deserialize(decoder: Decoder): MpLocalDateTime {
        val v = decoder.decodeSerializableValue(MpDateTimeRawData.serializer())

        val timezone = MpTimezone.of(v.timezone)

        return MpInstant.fromEpochMillis(v.ts).atZone(timezone).datetime
    }
}
